webpackJsonp([263],{

/***/ 1139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LaunchPageActivityDetail_vue__ = __webpack_require__(2770);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_555de862_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LaunchPageActivityDetail_vue__ = __webpack_require__(4485);
function injectStyle (ssrContext) {
  __webpack_require__(4479)
  __webpack_require__(4481)
  this["$style"] = __webpack_require__(4483)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-555de862"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LaunchPageActivityDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_555de862_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LaunchPageActivityDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2770:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  mixins: [],
  data: function data() {
    return {
      table: [{
        key: 'id',
        label: '活动ID',
        value: ''
      }, {
        key: 'title',
        label: '活动主题',
        value: ''
      }, {
        key: 'content',
        label: '活动描述',
        value: ''
      }, {
        key: 'skip_time',
        label: '跳过时间',
        value: ''
      }, {
        key: 'starttime',
        label: '上线时间',
        value: ''
      }, {
        key: 'endtime',
        label: '下线时间',
        value: ''
      }, {
        key: 'activity_url',
        label: '链接地址',
        value: ''
      }, {
        key: 'img_url',
        label: '图片地址',
        value: ''
      }]
    };
  },

  computed: Vuex.mapState({}),
  created: function created() {
    this.id = this.$route.params.id;
    this.id > 0 && this.setDetailData(this.id);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), {
    setDetailData: function setDetailData(id) {
      var _this = this;

      request.page('getLaunchPageActivityDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        _this.table.forEach(function (obj) {
          if (data[obj.key]) {
            obj.value = data[obj.key];
          }
        });
      });
    }
  })
});

/***/ }),

/***/ 4479:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4480);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("22c3dae5", content, true, {});

/***/ }),

/***/ 4480:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"LaunchPageActivityDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4481:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4482);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("72836cc1", content, true, {});

/***/ }),

/***/ 4482:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"LaunchPageActivityDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4483:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4484);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("18e34aa2", content, true, {});

/***/ }),

/***/ 4484:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"LaunchPageActivityDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/launch-page-activity/table"}},[_vm._v("活动管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-table',{staticClass:"margin b15",staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","show-header":false}},[_c('el-table-column',{attrs:{"width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(scope.row.label))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.key === 'img_url')?_c('div',[_c('img',{attrs:{"src":scope.row.value}})]):(scope.row.key === 'content')?_c('div',{domProps:{"innerHTML":_vm._s(scope.row.value)}}):_c('div',[_vm._v(_vm._s(scope.row.value))])]}}])})],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/launch-page-activity/table"}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("返回")])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/launch-page-activity-detail.a1ca86cfe21f57d9a6a9.js